import { render } from "./CardTen.vue?vue&type=template&id=3912a380"
import script from "./CardTen.vue?vue&type=script&lang=js"
export * from "./CardTen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__